import { Pipe, PipeTransform } from '@angular/core';
import { Routes } from '../../config/routes';

@Pipe({
    name: 'coreUrl',
    standalone: true,
})
export class CoreUrlPipe implements PipeTransform
{
    public transform(input: string) {
        return Routes.MakeLegFiCoreUrl(input);
    }
}
